export default [
    {
      region: 'AMG',
      colorAccent: '#00ABD7',
      municipios: [
        {
          municipio: `Zapopan`,
          colonias: [
            'Lomas del Refugio',
            'Nueva España',
            'Indígena de Mezquitán',
            'Benito Juárez Norte',
            'El Rehilete',
            'La Noria',
            'Valle de la Primavera',
            '12 de Diciembre',
            'Los Cerritos'
          ],
        },
        {
          municipio: `Guadalajara`,
          colonias: [
            'Hermosa Provincia',
            'Tetlán',
            'Tetlán II',
            'Insurgentes 1ra Sección',
            'Insurgentes 2da Sección',
            'Insurgentes 3ra Sección',
            'San Ramón',
            '5 de Mayo',
            'Fraccionamiento Arandas',
            'San José Río Verde 1ra Sección',
            'Oblatos 2da Sección'
          ],
        },
        {
          municipio: `Tlaquepaque`,
          colonias: [
            'Francisco I Madero 2da Sección',
            'Tateposco',
            'San Pedrito',
            'La Cofradía',
            'Potrero del Sauz',
            'Nueva Santa María'
          ],
        },
        {
          municipio: `Tlajomulco`,
          colonias: [
            'Arcos de San Sebastián',
            'Balcones de Santa Anita',
            'Lomas de San Agustín',
            'Jardines de San Sebastián',
            'La Victoria',
            'La Nueva Victoria',
            'Puerta Real',
            'La Fortuna',
            'La Gigantera'
          ],
        },
        {
          municipio: `Tonalá`,
          colonias: [
            'Santa Rosa',
            'El Vado',
            'Jauja',
            'Santa Isabel',
            'San Miguel La Punta',
            'Los Pajaritos',
            'Arroyo de en Medio'
          ],
        },
        {
          municipio: `El Salto`,
          colonias: [
            'El Verde',
            'San José del Quince',
            'Villas de Guadalupe',
            'San José del Castillo (El Castillo)'
          ],
        },
        {
          municipio: `Zapotlanejo`,
          colonias: [
            'Balcones de Huisquilco',
            'El Santuario',
            'Jardines del Paraíso',
            'La Cruz',
            'Agua Blanca'
          ],
        },
        {
          municipio: `Juanacatlán`,
          colonias: [
            'La Playa',
            'Tateposco',
            'Cabecera Municipal'
          ],
        },
        {
          municipio: `Ixtlahuacán de los Membrillos`,
          colonias: [
            'Bajío o Barrio Pobre',
            'Ojo de Agua',
            'Arena'
          ],
        },
      ]
    },
    {
      region: 'Interior',
      colorAccent: '#0D2C43',
      municipios: [
        {
          municipio: `Tototlán`,
          colonias: [
            'Cabecera Municipal (Centro)',
            'San Isidro',
            'El Ranchito'
          ]        
        },
        {
          municipio: `Poncitlán`,
          colonias: [
            'Mezcala',
            'La Cuesta de Mezcala'
          ]        
        },
        {
          municipio: `Ocotlán`,
          colonias: [
            'El Nuevo Fuerte',
            'Lázaro Cárdenas',
            '6 de Noviembre',
            'San Juan'
          ]        
        },
        {
          municipio: `La Barca`,
          colonias: [
            'La Paz de Ordaz',
            'Santa Cecilia',
            'El Abrevadero',
            'San Pedro de Ruiz'
          ]        
        },
        {
          municipio: `Jocotepec`,
          colonias: [
            'San Juan Cosalá',
            'Potrerillos',
            'El Chante (Chantepec)'
          ]        
        },
      ]
    }
];